<template>
  <img src="~/assets/icon/icon-info.svg" />
</template>
